import React, { useRef } from "react";
import { Colors } from "../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";
import { modalSideService } from "../services/modalSideService";
import { ConstantsFormCrud } from "../data/RoutesFormCrud";
import { ModalSide } from "./ModalSide";
import * as XLSX from "xlsx";
import { convertToString, validArray } from "../util/functions";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { generalService } from "../services/apiGenerales";
import { GlobalConstants } from "../data/GlobalConstants";
import { saveAs } from "file-saver";
import { isEmpty } from "../util/is";
import ExcelToJSON from "./ExcelToJSON";

const ExternalActionsTable = ({
	accionCrear,
	accionVisibilidadColumnas,
	accionExcel,
	accionSave,
	accionImportExcel,
	identificadorImportExcel = "file",
	downloadTemplate,
	customActions,
	customPlantillas,
}) => {
	let location = useLocation();
	const permissions = useSelector((state) => state.permissions);
	const idRef = useRef(Math.floor(Math.random() * 100000));
	const dispatch = useDispatch();

	const handleOpenVisibilidadColumnas = (tableRef) => {
		modalSideService.showModal({
			props: { tableRef },
			type: ConstantsFormCrud.modalVisibilityColumns,
			title: `Cambiar la visibilidad de las columnas`,
			isAddMode: false,
			isEditable: false,
			dense: true,
			id: `modalVisibilidadColumnas${idRef.current}`,
			size: `lg`,
		});
	};

	const handleExportExcel = (accionExcel) => {
		const {
			tableRef,
			fileName,
			sheetName,
			structure,
			excludeFieldsNumeric = {},
			exportCellRendererColumns = [],
		} = accionExcel;

		let headers = [],
			headersFather = [],
			campos = [],
			data = [];
		let sizeFathers = {};
		let sizeCount = 0;

		if (validArray(structure).length > 0) {
			for (let item of structure) {
				headers.push(item.fieldNew);
				campos.push(item);
			}

			data.push(headers);

			tableRef?.current?.api?.forEachNodeAfterFilter((nodo) => {
				let temp = [];

				campos.forEach((campo) => {
					if (!isEmpty(campo?.fieldOld)) {
						if (!isNaN(Number(nodo.data[campo?.fieldOld]))) {
							if (convertToString(nodo.data[campo?.fieldOld]).startsWith("0")) {
								temp.push(nodo.data[campo?.fieldOld]);
							} else {
								if (excludeFieldsNumeric[campo?.fieldOld]) {
									temp.push(nodo.data[campo?.fieldOld]);
								} else {
									temp.push(nodo.data[campo?.fieldOld]);
								}
							}
						} else {
							temp.push(nodo.data[campo?.fieldOld]);
						}
					} else {
						temp.push("");
					}
				});

				data.push(temp);
			});
		} else {
			tableRef?.current?.api?.getColumnDefs().map((colDef) => {
				if (exportCellRendererColumns.some((col) => col == colDef.field) || !colDef.cellRenderer) {
					if (colDef.children) {
						colDef.children.forEach((child) => {
							headersFather.push(colDef.headerName);
							headers.push(child.headerName);
							campos.push(child.field);
						});

						sizeFathers[colDef.headerName] = {};
						sizeFathers[colDef.headerName]["start"] = sizeCount;
						sizeCount += colDef.children.length;
						sizeFathers[colDef.headerName]["end"] = sizeCount - 1;
					} else {
						headers.push(colDef.headerName);
						campos.push(colDef.field);
					}
				}
			});

			headersFather.length && data.push(headersFather);
			data.push(headers);

			tableRef?.current?.api?.forEachNodeAfterFilter((nodo) => {
				let temp = [];

				campos.forEach((campo) => {
					if (!isNaN(Number(nodo.data[campo]))) {
						if (convertToString(nodo.data[campo]).startsWith("0")) {
							temp.push(nodo.data[campo]);
						} else {
							if (excludeFieldsNumeric[campo]) {
								temp.push(nodo.data[campo]);
							} else {
								temp.push(Number(nodo.data[campo]));
							}
						}
					} else {
						temp.push(nodo.data[campo]);
					}
				});

				data.push(temp);
			});
		}

		createXlsxFile(data, sheetName, fileName, sizeFathers);
	};

	const createXlsxFile = (data, sheetName, fileName, sizeFathers) => {
		let worksheet = XLSX.utils.aoa_to_sheet(data);
		let new_workbook = XLSX.utils.book_new();

		if (sizeFathers) {
			worksheet["!merges"] = Object.keys(sizeFathers).map((key) => {
				return {
					s: { r: 0, c: sizeFathers[key].start },
					e: { r: 0, c: sizeFathers[key].end },
				};
			});
		}

		XLSX.utils.book_append_sheet(new_workbook, worksheet, sheetName);
		XLSX.writeFile(new_workbook, `${fileName}.xlsx`);
	};

	const handleDownloadTemplate = (datos) => {
		generalService.getPlantilla(datos).then(
			(response) => {
				try {
					let blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
					saveAs(blob, `${datos.template}.xlsx`);
				} catch (e) {
					dispatch({
						type: "setStateAlert",
						alert: {
							type: GlobalConstants.alertError,
							message: `Ha ocurrido un error descargando la plantilla, verifica el estado de la plantilla a descargar`,
						},
					});
				}
			},
			(error) => {
				dispatch({
					type: "setStateAlert",
					alert: {
						type: GlobalConstants.alertError,
						message: `Ha ocurrido un error descargando la plantilla, verifica la ruta de la plantilla a descargar`,
					},
				});
			},
		);
	};

	return (
		<div className='d-flex justify-content-end align-items-center'>
			{accionVisibilidadColumnas && (
				<Tooltip title='Visibilidad Columnas' aria-label='visibilidad-columnas'>
					<a
						className='icon-container-actions d-flex'
						onClick={() => handleOpenVisibilidadColumnas(accionVisibilidadColumnas)}
					>
						<div style={{ backgroundColor: Colors.COLOR_AMOVIL_BLUE_DARK }} />
						<i style={{ color: Colors.COLOR_AMOVIL_BLUE_DARK }} className='fas fa-eye fa-2x' />
					</a>
				</Tooltip>
			)}

			{accionCrear && (
				<React.Fragment>
					{permissions[location.pathname]?.C === "S" ? (
						<Tooltip title='Crear (+)' aria-label='crear'>
							<a onClick={accionCrear} className='icon-container-actions d-flex'>
								<div style={{ backgroundColor: Colors.COLOR_BLUE_THEME }} />
								<i style={{ color: Colors.COLOR_BLUE_THEME }} className='fas fa-plus fa-2x' />
							</a>
						</Tooltip>
					) : (
						<Tooltip title='No tienes permisos para crear' aria-label='crear'>
							<a className='icon-container-actions d-flex'>
								<div style={{ backgroundColor: Colors.DARK_GRAY }} />
								<i style={{ color: Colors.DARK_GRAY }} className='fas fa-plus fa-2x' />
							</a>
						</Tooltip>
					)}
				</React.Fragment>
			)}

			{accionExcel && (
				<React.Fragment>
					{permissions[location.pathname]?.U === "S" || permissions[location.pathname]?.R === "S" ? (
						<Tooltip title='Exportar Excel' aria-label='exportar-excel'>
							<a className='icon-container-actions d-flex' onClick={() => handleExportExcel(accionExcel)}>
								<div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
								<i style={{ color: Colors.COLOR_GREEN_DARK }} className='far fa-file-excel fa-2x' />
							</a>
						</Tooltip>
					) : (
						<Tooltip title='No tienes permisos para exportar' aria-label='exportar-excel'>
							<a className='icon-container-actions d-flex'>
								<div style={{ backgroundColor: Colors.DARK_GRAY }} />
								<i style={{ color: Colors.DARK_GRAY }} className='far fa-file-excel fa-2x' />
							</a>
						</Tooltip>
					)}
				</React.Fragment>
			)}

			{accionSave && (
				<React.Fragment>
					{permissions[location.pathname]?.C === "S" || permissions[location.pathname]?.U === "S" ? (
						<Tooltip title='Guardar Producto' aria-label='guardar-producto'>
							<a className='icon-container-actions d-flex' onClick={accionSave}>
								<div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
								<i style={{ color: Colors.COLOR_GREEN_DARK }} className='far fa-save fa-2x' />
							</a>
						</Tooltip>
					) : (
						<Tooltip title='No tienes permisos para guardar' aria-label='guardar-producto'>
							<a className='icon-container-actions d-flex '>
								<div style={{ backgroundColor: Colors.DARK_GRAY }} />
								<i style={{ color: Colors.DARK_GRAY }} className='far fa-save fa-2x' />
							</a>
						</Tooltip>
					)}
				</React.Fragment>
			)}

			{downloadTemplate && (
				<React.Fragment>
					{permissions[location.pathname]?.C === "S" || permissions[location.pathname]?.U === "S" ? (
						<Tooltip title='Descargar Plantilla'>
							<a className='icon-container-actions d-flex' onClick={() => handleDownloadTemplate(downloadTemplate)}>
								<div style={{ backgroundColor: Colors.ORANGE }} />
								<i style={{ color: Colors.ORANGE }} className='fas fa-file-download fa-2x' />
							</a>
						</Tooltip>
					) : (
						<Tooltip title='No tienes permisos para descargar'>
							<a className='icon-container-actions d-flex '>
								<div style={{ backgroundColor: Colors.DARK_GRAY }} />
								<i style={{ color: Colors.DARK_GRAY }} className='fas fa-file-download fa-2x' />
							</a>
						</Tooltip>
					)}
				</React.Fragment>
			)}

			{accionImportExcel && (
				<React.Fragment>
					{permissions[location.pathname]?.C === "S" || permissions[location.pathname]?.U === "S" ? (
						<ExcelToJSON
							identificador={identificadorImportExcel}
							handleChange={(datos, file) => accionImportExcel(datos[0], file)}
							titleTooltip='Carga Masiva'
						/>
					) : (
						<Tooltip title='No tienes permisos para realizar carga masiva'>
							<a className='icon-container-actions d-flex'>
								<div style={{ backgroundColor: Colors.DARK_GRAY }} />
								<i style={{ color: Colors.DARK_GRAY }} className='fas fa-file-upload fa-2x' />
							</a>
						</Tooltip>
					)}
				</React.Fragment>
			)}

			{customActions && (
				<React.Fragment>
					{permissions[location.pathname]?.C === "S" || permissions[location.pathname]?.U === "S" ? (
						customActions
					) : (
						<Tooltip title='No tienes permisos para utilizar acciones personalizadas'>
							<a className='icon-container-actions d-flex'>
								<div style={{ backgroundColor: Colors.DARK_GRAY }} />
								<i style={{ color: Colors.DARK_GRAY }} className='fas fa-user-lock fa-2x' />
							</a>
						</Tooltip>
					)}
				</React.Fragment>
			)}

			{customPlantillas && (
				<React.Fragment>
					{permissions[location.pathname]?.R === "S" ? (
						customPlantillas
					) : (
						<Tooltip title='No tienes permisos para utilizar acciones personalizadas'>
							<a className='icon-container-actions d-flex'>
								<div style={{ backgroundColor: Colors.DARK_GRAY }} />
								<i style={{ color: Colors.DARK_GRAY }} className='fas fa-user-lock fa-2x' />
							</a>
						</Tooltip>
					)}
				</React.Fragment>
			)}

			<ModalSide id={`modalVisibilidadColumnas${idRef.current}`} />
		</div>
	);
};

export default ExternalActionsTable;
